import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Card } from 'react-bootstrap'

interface HighlightableCardProps {
  children: React.ReactNode
  className?: string
  [key: string]: any
}

export interface HighlightableCardRef {
  triggerHighlight: () => void
  scrollIntoView: () => void
}

const HighlightableCard = forwardRef<HighlightableCardRef, HighlightableCardProps>(
  ({ children, className = '', ...props }, ref) => {
    const [showAnimation, setShowAnimation] = useState(false)
    const cardRef = useRef<HTMLDivElement>(null)

    useImperativeHandle(ref, () => ({
      triggerHighlight: () => {
        setShowAnimation(true)
        setTimeout(() => setShowAnimation(false), 1000)
      },
      scrollIntoView: () => {
        cardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }))

    return (
      <Card 
        {...props} 
        ref={cardRef}
        className={`${className} ${showAnimation ? 'card-highlight-animation' : ''}`}
      >
        {children}
      </Card>
    )
  }
)

HighlightableCard.displayName = 'HighlightableCard'

export default HighlightableCard
